import { BlockComponentModel } from '@/cms/types/blok-component';
import { Video, VideoProps } from '@/components/atoms/Video';

export interface VideoStrapiProps {
  url: VideoProps['url'];
}

export default function VideoStrapi({
  block,
}: BlockComponentModel<VideoStrapiProps>) {
  return <Video {...block} classNames={{ container: 'max-w-[1024px]' }} />;
}
